import { ORDENABLE_PAGE_SIZE } from '@/constants';
import { DashboardLessonProgressFilters } from '@/data/services/dashboardLessonProgress';

export const LESSON_NEIGHBORS_PAGE_SIZE = 20;

export const courseLessonProgressFilters = (
  courseProgressId?: number,
  pageSize: number = ORDENABLE_PAGE_SIZE,
): DashboardLessonProgressFilters => ({
  courseProgressId: courseProgressId ? [courseProgressId] : undefined,
  orderBy: 'scheduled_lesson_order',
  pageSize,
});
